import * as blogConstants from '../constants/blogConstants'

export const blogsReducer = (state = { loading: true, blogs: [], type: 'NOTHING_HAPPENED' }, action) => {
  switch (action.type) {
    case blogConstants.BLOG_LIST_REQUEST:
      return { ...state, loading: true, type: blogConstants.BLOG_LIST_REQUEST };
    case blogConstants.BLOG_LIST_SUCCESS:
      return { ...state, loading: false, blogs: action.payload.data, type: blogConstants.BLOG_LIST_SUCCESS };
    case blogConstants.BLOG_LIST_FAIL:
      return { ...state, loading: false, error: action.payload, type: blogConstants.BLOG_LIST_FAIL };
    case blogConstants.BLOG_DETAILS_REQUEST:
      return { ...state, loading: true, type: blogConstants.BLOG_DETAILS_REQUEST };
    case blogConstants.BLOG_DETAILS_SUCCESS:
      return { ...state, loading: false, blog: action.payload.data, type: blogConstants.BLOG_DETAILS_SUCCESS };
    case blogConstants.BLOG_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload, type: blogConstants.BLOG_DETAILS_FAIL };
    case blogConstants.BLOG_DELETE_REQUEST:
      return { ...state, loading: true, type: blogConstants.BLOG_DELETE_REQUEST };
    case blogConstants.BLOG_DELETE_SUCCESS:
      return { ...state, loading: false, type: blogConstants.BLOG_DELETE_SUCCESS };
    case blogConstants.BLOG_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload.data, type: blogConstants.BLOG_DELETE_FAIL };
    case blogConstants.BLOG_UPDATE_REQUEST:
      return { ...state, loading: true, type: blogConstants.BLOG_UPDATE_REQUEST };
    case blogConstants.BLOG_UPDATE_SUCCESS:
      return { ...state, loading: false, type: blogConstants.BLOG_UPDATE_SUCCESS };
    case blogConstants.BLOG_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload, type: blogConstants.BLOG_UPDATE_FAIL };
    case blogConstants.BLOG_CREATE_REQUEST:
      return { ...state, loading: true, type: blogConstants.BLOG_CREATE_REQUEST };
    case blogConstants.BLOG_CREATE_SUCCESS:
      return { ...state, loading: false, type: blogConstants.BLOG_CREATE_SUCCESS };
    case blogConstants.BLOG_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload, type: blogConstants.BLOG_CREATE_FAIL };
    case blogConstants.BLOG_WATCHED_REQUEST:
      return { ...state, loading: true, type: blogConstants.BLOG_WATCHED_REQUEST };
    case blogConstants.BLOG_WATCHED_SUCCESS:
      return { ...state, loading: false, type: blogConstants.BLOG_WATCHED_SUCCESS };
    case blogConstants.BLOG_WATCHED_FAIL:
      return { ...state, loading: false, error: action.payload.data, type: blogConstants.BLOG_WATCHED_FAIL };
    default:
      return state;
  }
}